import { Injectable, inject } from '@angular/core';

import {
    Plan,
    PromotionModel,
    PromotionsModel,
    PromotionsService,
    QuoteModel,
    TYPE_MARKETING
} from '@bytel/bytel-sales';
import { CheckoutStorageService } from '@bytel/checkout';

import { PromotionsHelper } from '@base/helper/promotions.helper';

import { MainCartService } from '@services/main-cart.service';
import { MixedCartService } from '@services/mixed-cart.service';

@Injectable({
    providedIn: 'root',
})
export class PromoHomeService {
    private storageService: CheckoutStorageService = inject(CheckoutStorageService);
    private cartService: MainCartService = inject(MainCartService);
    private mixedCartService: MixedCartService = inject(MixedCartService);

    getPromos(subscription: Plan, promotions: PromotionsModel): PromotionsModel {
        return PromotionsService.GetPromotionsForProduct(subscription, promotions);
    }

    getIncitationPromos(subscription: Plan, promotions: PromotionsModel): PromotionModel[] {
        return this.getPromos(subscription, promotions).incitation;
    }

    getAutomaticPromos(subscription: Plan, promotions: PromotionsModel): PromotionModel[] {
        return this.getPromos(subscription, promotions).automatic;
    }

    getIncitativePromosHome(subscription: Plan, promotions: PromotionsModel): PromotionModel[] {
        return PromotionsHelper.GetPromotionsByMarketingType(
            this.getIncitationPromos(subscription, promotions),
            TYPE_MARKETING.FOYER,
        );
    }

    getAutomaticPromosHome(subscription: Plan, promotions: PromotionsModel): PromotionModel[] {
        return PromotionsHelper.GetPromotionsByMarketingType(
            this.getAutomaticPromos(subscription, promotions),
            TYPE_MARKETING.FOYER,
        );
    }

    getApplicablePromoHome(
        subscription: Plan,
        promotions: PromotionsModel,
        isConnected: boolean,
    ): PromotionModel | undefined {
        const isMixedCart = this.mixedCartService.isMixedCart(this.cartService.cartModel);
        const quote: QuoteModel = this.cartService.getQuote();
        if (isConnected || isMixedCart) {
            const automaticPromosHome = this.getAutomaticPromosHome(subscription, promotions);
            return automaticPromosHome[0];
        }
        const promoConfig = this.storageService.get('promoConfigurator', false);
        const [isFai, isMobile] = [quote.isAcquisitionFix(), quote.isAcquisition()];

        if (promoConfig?.mobile && isFai) {
            // il n'y a pas de promo BIG incitative dans le parcours FAI, il faut récupérer le fanion à partir de la promo automatique qui remonte
            const promo = this.getAutomaticPromos(subscription, promotions);
            return promo?.[0];
        }
        if (promoConfig?.home && isMobile) {
            const incitativePromosHome = this.getIncitativePromosHome(subscription, promotions);
            return incitativePromosHome[0];
        }
    }
}
